import React, { useEffect, useState } from "react";
import FeedCard from "../../Feed/FeedCard";
import { FEED_CHANNELS } from "../../Feed/feeds.config";
import api from "../../../services/api";
import { hasPlanFeature } from "../../../services/auth";
import PlanFeatureUpgradeModal from "../../../components/PlanFeatureUpgradeModal";
import "../../Feed/styles.scss";

const FeedsTab = () => {
    // Config de cada canal vinda do backend, indexada por type (= slug do config).
    const [feeds, setFeeds] = useState({});
    const [showUpgrade, setShowUpgrade] = useState(false);

    useEffect(() => {
        api.get("/catalog-feeds").then((res) => {
            const byType = {};
            res.data.resources.forEach((feed) => {
                byType[feed.type] = feed;
            });
            setFeeds(byType);
        });
    }, []);

    const toggle = (slug) => {
        const nextEnabled = !feeds[slug]?.enabled;

        // Ativar feed exige o recurso de plano 'catalog_feed'. Sem ele, mostra o
        // modal de upgrade em vez de chamar a API (o backend também bloqueia).
        if (nextEnabled && !hasPlanFeature("catalog_feed")) {
            setShowUpgrade(true);
            return;
        }

        // Atualização otimista; reverte se a API falhar.
        setFeeds((prev) => ({ ...prev, [slug]: { ...prev[slug], enabled: nextEnabled } }));

        api.put(`/catalog-feeds/${slug}`, { enabled: nextEnabled })
            .then((res) => {
                setFeeds((prev) => ({ ...prev, [slug]: res.data.resource }));
            })
            .catch(() => {
                setFeeds((prev) => ({ ...prev, [slug]: { ...prev[slug], enabled: !nextEnabled } }));
            });
    };

    return (
        <>
            <p className="integration-tab-intro">
                Disponibilize seu catálogo em formato XML para marketplaces, redes sociais e
                comparadores de preço consultarem automaticamente.
            </p>

            <div className="feeds-grid">
                {FEED_CHANNELS.map((channel) => (
                    <FeedCard
                        key={channel.slug}
                        channel={channel}
                        enabled={feeds[channel.slug]?.enabled ?? false}
                        feedUrl={feeds[channel.slug]?.feed_url}
                        onToggle={toggle}
                    />
                ))}
            </div>

            <PlanFeatureUpgradeModal
                feature="catalog_feed"
                show={showUpgrade}
                close={() => setShowUpgrade(false)}
            />
        </>
    );
};

export default FeedsTab;
